<template>
    <div class="footer text-sm-left text-center secondary white--text">
        <v-container fluid class="footer-items">
            <v-container grid-list-lg>
                <v-layout row wrap>
                    <v-flex xs12 sm4 class="text-center white--text mobile-padding">
                        <img :src="require('../assets/icons/adress_icon.png')" style="max-width: 30px;" />
                        <div class="mt-2">
                            <p class="mb-0">Dělnická 213/12, Holešovice</p>
                            <p class="mb-0">170 00, Praha 7</p>
                        </div>
                    </v-flex>
                    <v-flex xs12 sm4 class="text-center white--text mobile-padding">
                        <img :src="require('../assets/icons/email_icon.png')" style="max-width: 30px;" />
                        <div class="mt-2">
                            <p class="mb-0">ceproas@ceproas.cz</p>
                        </div>
                    </v-flex>
                    <v-flex xs12 sm4 class="text-center white--text mobile-padding">
                        <img :src="require('../assets/icons/phone_icon.png')" style="max-width: 30px;" />
                        <div class="mt-2">
                            <p class="mb-0">+420 221 968 228</p>
                        </div>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-container>
        <v-container fluid class="footer-info primary">
            <v-container class="text-center">
                <p class="mb-0 secondary--text">Copyright © 2020 ČEPRO, a. s.</p>
            </v-container>
        </v-container>
    </div>
</template>

<script>
    export default {
        name: 'Footer',
        data: () => {
            return {
                items: [
                    {
                        title: 'Adresa',
                        text: 'Za Hotely 814, 252 62, Horoměřice, Česká republika​'
                    },
                    {
                        title: 'Telefon',
                        text: '+420 777 444 545'
                    },
                    {
                        title: 'Email',
                        text: 'info@policecard.cz'
                    }
                ]
            }
        }
    }
</script>

<style lang="scss">
    .footer {
        margin-top: -8px;
        .footer-items {
            padding: 50px 0 ;
        }
        @media #{$pixel-less-phone} {
           .mobile-padding {
               padding-top: 1rem !important;
               padding-bottom: 1rem !important;
           }
        }
        a.no-decoration {
            text-decoration: none;
        }
        img {
            max-width: 100px;
            height: auto;
        }
        h2 {
            font-size: 31px;
            margin-bottom: 20px;
            @media #{$pixel-less-phone} {
                padding-top: 30px;
            }
        }
        .divider {
            margin: auto;
            padding: 20px 0;
        }
        .footer-info {
            background-color: #f6f9f9;
            img {
                width: 45%;
            }
            h5 {
                font-size: 18px;
                margin-bottom: 20px;
            }
        }
    }
</style>